module.exports = __webpack_public_path__ + "img/loading.69fdc104.svg";